/** Work and system notices at the screen edge and in the tray. */
export default {
  denkerHelper: "Denker helper",
  stateWorking: "Working",
  stateQuestion: "Question",
  stateApproval: "Needs approval",
  stateBlocked: "Blocked",
  stateDone: "Done",
  stateFailed: "Failed",
  stateStopped: "Stopped",
  usingYourComputer: "Using your computer",
  needsYourAnswer: "Needs your answer",
  answered: "Answered",
  questionStep: "Question {index} of {count}",
  answerByVoice: "Answer by voice",
  followUpByVoice: "Follow up by voice",
  typeAnswer: "Type answer",
  typeFollowUp: "Type follow up",
  answerPlaceholder: "Or answer in your own words…",
  followUpPlaceholder: "Send a follow-up…",
  stop: "Stop",
  deny: "Deny",
  allow: "Allow",
  openChat: "Open chat",
  openTask: "Open task",
  openInApp: "Open in {app}",
  openInAppFallback: "Open in app",
  openApp: "Open app",
  clear: "Clear",
  more: "More",
  collapse: "Collapse",
  expand: "Expand",
  showFullPanel: "Show full panel",
  latestScreenshot: "Latest screenshot",
  dictate: "Dictate",
  stopDictation: "Stop dictation",
  send: "Send",
  sendFailed: "Couldn’t send. Please try again.",
  stopFailedTitle: "Couldn't stop this run",
  stopLostTask:
    "This card lost its task reference — dismiss it from the menu instead.",
  stopNotConnected: "Not connected — reconnect and try again.",
  openChatFailed: "Couldn't open the chat",
  showAgentActivity: "Show {name} activity",
  actionFailed: "Action failed",
  dismissNotification: "Dismiss notification",
  levelSystem: "System",
  levelWarning: "Warning",
  levelError: "Error",
  stackNeedYou: { one: "+{count} needs you", other: "+{count} need you" },
  stackOpen: "open",
  stackMore: "+{count} more",
  stackShow: "show",
  stackShowLess: "Show less",
  reconnecting: "Reconnecting…",
  reconnectEscalated: "Reconnection keeps failing — quit and reopen Denker.",
  reconnectFailed:
    "Could not reconnect the companion. Try again or restart Denker.",
  stillDisconnected:
    "The companion is still disconnected. Try again or restart Denker.",
  voiceNeedsAttention: "Voice needs attention",
  voiceSettings: "Voice settings",
  voiceWakeUnavailable: "Voice wake is unavailable. Check voice settings.",
  voiceInputFailed: "Voice input failed. Please try again.",
  noMicrophoneAudio:
    "No microphone audio detected. Check the microphone input in voice settings.",
  liveVoiceUnavailable: "Live voice is unavailable. Check voice settings.",
} as const;
